import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/articles';

export default function ArticleCardsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            Sugargoo Spreadsheet Resources &amp; Guides
          </h2>
          <p className="mt-3 text-foreground-500 max-w-2xl mx-auto text-sm md:text-base">
            Explore our collection of in-depth guides, reviews, and expert tips to help you get the most out of your Sugargoo shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articleCards.map((card) => (
            <Link
              key={card.slug}
              to={`/${card.slug}`}
              className="group bg-background-100 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-grow">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed flex-grow">
                  {card.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  Read Article
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}